<template>
  <div>
    <surveys-table
      surveyName="SCORAD"
      surveyCode="SCORAD"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_SCORAD,
        viewDetail: permissions.SEE_DETAIL_SURVEY_SCORAD,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
